import { useEffect } from "react";

// Título base da aba (site). Cada página passa só o seu sufixo:
// usePageTitle("Histórico") => "Rede Frota | Histórico".
// Sem argumento => volta ao base (aba padrão, esperando login).
const BASE = "Rede Frota | Entrada";

export function usePageTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `Rede Frota | ${title}` : BASE;
    return () => {
      document.title = BASE;
    };
  }, [title]);
}
